<template>
  <div class="bgGra">
    <div class="v-header">

      <div class="header">
        <!--        <img src="@/assets/images/logo.png" alt="">-->
        <div>
          <span @click="toIndex">首页</span>
          <span class="onclick">资讯合作</span>
          <span>车管家</span>
          <span class="cooperation_container" @click="toggleShow">业务合作
            <ul v-if="isShow" class="slide-menu">
            <li style="background:rgba(255, 255, 255, 0.8);margin-top:5px;">
              <a href="https://www.cpicagency.com.cn/home" target="_ablank">太平洋保险代理</a>
            </li>
            <li style="background:rgba(255, 255, 255, 0.8);margin-top:5px;">
              <a href="http://www.jxzwfww.gov.cn/jxzw/gft/index.do" target="_ablank">赣服通</a>
            </li>
            <li style="background:rgba(255, 255, 255, 0.8);margin-top:5px;">
              <a href="https://pc.shengshidalian.cn/#/" target="_ablank">盛大车险</a>
            </li>
            <li style="background:rgba(255, 255, 255, 0.8);margin-top:5px;">
              <a href="tpic.html" target="_ablank">太平洋保险</a>
            </li>
            <li style="background:rgba(255, 255, 255, 0.8);margin-top:5px;">
              <a href="gric.html" target="_ablank">国任保险</a>
            </li>
            <li style="background:rgba(255, 255, 255, 0.8);margin-top:5px;">
              <a href="ygic.html" target="_ablank">阳光保险</a>
            </li>
            <li style="background:rgba(255, 255, 255, 0.8);margin-top:5px;">
              <a href="javascript:;">平安保险</a></li>
            <li style="background:rgba(255, 255, 255, 0.8);margin-top:5px;">
              <a href="https://mp.weixin.qq.com/s/bAqx9hxX0nlgPToCwx_FQQ" target="_ablank">太保服务，护航亚运</a></li>
            <li style="background:rgba(255, 255, 255, 0.8);margin-top:5px;">
              <a href="https://mp.weixin.qq.com/s/jriw0wpTQjXuVyh1hDvOQg" target="_ablank">无锡太保</a>
            </li>
            <li style="background:rgba(255, 255, 255, 0.8);margin-top:5px;">
              <a href="https://mp.weixin.qq.com/s/V9tHFbV4kBDMKoCtjS1ukQ" target="_ablank">无锡太保客户节</a>
            </li>
              <li style="background:rgba(255, 255, 255, 0.8);margin-top:5px;">
              <a href="http://www.djbx.com/" target="_ablank">大家保险</a>
            </li>
          </ul>
          </span>
          <span>关于我们</span>
        </div>
      </div>
    </div>

    <div class="banner_img">
      <img src="@/assets/images/banner.png" width="100%">
    </div>

    <div class="order-list-w">
      <div
          v-for="(order,index) in orderList"
          :key="order.type"
          :data-item="order"
          class="order-item-w"
          @click="onSelectOrder(order)">
        <img :src="order.mobileMainImage" class="type-ic-w"/>
        <div class="t-ct-w">
          <p v-if="order.title">{{ order.title }}</p>
          <p v-if="order.releaseTime" class="t-ct-children">
            <span>阅读量：{{ order.pcReadNum }}</span>
            <span class="zan" @click.stop="toZan(order,index)">
              <van-icon v-if="!order.like" color="#333333" name="good-job-o"/>
              <van-icon v-else color="#1989fa" name="good-job"/>
              {{ order.pcLikeNum }}
            </span>
            <span class="collect" @click.stop="toCollect(order,index)">
              <van-icon v-if="!order.collect" color="#333333" name="star-o"/>
              <van-icon v-else color="#1989fa" name="star"/>
              {{ order.pcCollectNum }}
            </span>
          </p>
        </div>
        <!--<img class="ic-s" src="/static/images/shape.png" />-->
      </div>


    </div>

  </div>
</template>

<script>
import {Resource} from '@/services/resource';
import {Popup, Toast} from 'mint-ui';

// import { createApp } from 'vue';
import {Icon} from 'vant';
import Vue from "vue";

Vue.component(Popup.name, Popup);
Vue.use(Icon);


export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "标题"
    }
  },
  created() {
  },
  mounted() {
    // document.body.style.backgroundColor = "#EFEFF1";
    this.fetchOrderList();
  },

  data() {
    return {
      like: false,
      isShow: false,
      num: "",
      recordlist: false,
      recordData: {},
      dialogWhetherShow: false,
      showF: false,
      pcCollectNum: "1233", //收藏量
      pcLikeNum: "231", //网站点赞量
      pcReadNum: "300", //网站阅读量
      orderList: [{
        id: null,
        title: "",
        releaseTime: "",
        mobileMainImage: "",
        pcReadNum: "",
        pcLikeNum: "",
        pcCollectNum: ""
      }]
    };
  },

  methods: {

    toggleShow() {
      this.isShow = !this.isShow;
    },
    // 跳转页面
    pageTo(name) {
      this.$router.push(name);

    },
    // 返回上一页
    goBack() {
      this.$router.go(-1);
    },
    toIndex() {

      this.$router.push("/index");
    },
    getUrlParam(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    },

    fetchOrderList() {
      Resource.promotionList.post({}, {
        // 1丞乐 2娄铎
        platform: 1,
        mainCompanyCode: 1
      }).then(res => {
        res.data.length > 0 && res.data.forEach(item => {
          item.like = false
          item.collect = false
        })
        this.orderList = res.data;
      })
    },

    onSelectOrder(order) {
      // let { item } = e.currentTarget.dataset
      console.log(order)
      if (order.contentType === 1) {
        this.$router.push({
          name: 'article',
          query: {id: order.id}
        });
      }
      if (order.contentType === 0) {
        window.open(order.content)
      }
    },

    toZan(order, index) {
      Resource.likeClick.post({}, {
        action: 1,
        id: order.id,
        platform: 1
      }).then(() => {
        Toast({message: "点赞成功！", position: "middle"});
        this.orderList[index].pcLikeNum++
        this.orderList[index].like = true
      })
    },

    toCollect(order, index) {
      Resource.collectClick.post({}, {
        action: 1,
        id: order.id,
        platform: 1
      }).then(res => {
        if (res.code === 'SUCCESS') {
          Toast({message: "点赞成功！", position: "middle"});
          this.orderList[index].pcCollectNum++
          this.orderList[index].collect = true
        } else {
          Toast(res.message)
        }
      })
    }

  }
};
</script>
<style lang="less" scoped>
@import url("./style.less");

.carouse_container {
  width: 100%;
  height: 500px;
}

.cooperation_container {
  position: relative;
  display: inline-block;

  .slide-menu {
    z-index: 999;
    text-align: center;
    position: absolute;
    width: 140px;
    background: rgba(255, 255, 255, 0.8);
    height: 29px;
    line-height: 40px;
    font-size: 13px;

    li a {
      color: #666;
    }
  }
}

.banner_img {
  background: #56BA74;
  position: relative;
}

.zan, .collect {
  cursor: pointer;
}
</style>
